/**
 * PlanningEventLogEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectUserEntity } from "../ProjectUserEntity";
import { PlanningEventEntity } from "../PlanningEventEntity";
import { PlanningEventLogEntity } from "../PlanningEventLogEntity";
declare global {
    interface EntityTypeMap {
        PlanningEventLog: PlanningEventLogEntity;
    }
}
export abstract class PlanningEventLogGeneratedEntity extends BaseEntity {
    public abstract planningEventLogId: string;
    public abstract progress: number;
    public abstract creationDate: Date;
    public abstract user: ProjectUserEntity | null;
    public abstract planningEvent: PlanningEventEntity;
}
